const env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV

const API_BASE_URL_LIST = {
  "development":  "https://582codbyqa.execute-api.ap-northeast-1.amazonaws.com/api",
  "staging":     "https://hx58asi6ug.execute-api.ap-northeast-1.amazonaws.com/api",
  "production": "https://3vgexryf2b.execute-api.ap-northeast-1.amazonaws.com/api"
}
const API_BASE_URL = API_BASE_URL_LIST[env_key]

const QUESTIONNAIRE_URL_LIST = {
  "development":  "https://logoform.jp/f/cf9FZ/2407531?key=84760e1c9138ef7f55b9e686827e1adff7f69cb34668390193a1ccfaddf446ad",
  "staging":     "https://logoform.jp/f/cf9FZ/2407531?key=84760e1c9138ef7f55b9e686827e1adff7f69cb34668390193a1ccfaddf446ad",
  "production": "https://logoform.jp/form/tbbj/574452"
}
const QUESTIONNAIRE_URL = QUESTIONNAIRE_URL_LIST[env_key]

const API_ID = "Chofu"
const SITE_TITLE = "お出かけ情報サービス"
const API_MIXWAY_PATH = "https://mixway.ekispert.jp/v1/json/"
const AVAILABLE_LANGUAGES = ['ja', 'en', 'zh-TW']
// このエリアを検索のボタン表示
const ENABLED_MAP_SEARCH_PLACE = true
// 名称検索時に表示するPOIの最大数
const MAX_SEARCH_PLACE = 20
const API_KEY = "j8bs7t3fS6ckVZ3h"
// 検索時の最大駅数
const MAX_SEARCH_STATION = 5


const JREAST_APP_SCHEMA = "https://jreastapp.page.link"
const JREAST_PC_SITE = "https://play.google.com/store/apps/details?id=jp.co.jreast&hl=ja"
const MIXWAY_URL = "https://mixway.ekispert.net"

// 中心となる駅
const DEFAULT_STATION_LOCATION = {
  latitude: 35.651788,
  longitude: 139.5422074
}

const DEFAULT_MY_LOCATION_RADIUS = 30

const LINK_BASE_URL_LIST = {
  "development": "https://dev.g3m.jp",
  "staging": "https://stg.g3m.jp",
  "production": "https://g3m.jp"
}
const LINK_BASE_URL = LINK_BASE_URL_LIST[env_key]

const REAL_TIME_SEARCH_WEB_LIST = {
  "development": "https://transit-stg.jre-maas.com/",
  "staging": "https://transit.jre-maas.com/",
  "production": "https://transit.jre-maas.com/"
}
const REAL_TIME_SEARCH_WEB=REAL_TIME_SEARCH_WEB_LIST[env_key]

const BUS_LOCATION_API_URL = "https://l102b1vo5l.execute-api.ap-northeast-1.amazonaws.com/stg/v1/"
const BUS_LOCATION_API_KEY = "5mwdWojcjm3pXgOZadGiX5ORXujM2yDE5Xge1bS7"
const BUS_LOCATION_TRIP_COUNT = 3

export default {
  API_ID: API_ID,
  SITE_TITLE: SITE_TITLE,
  API_MIXWAY_PATH: API_MIXWAY_PATH,
  AVAILABLE_LANGUAGES: AVAILABLE_LANGUAGES,
  ENABLED_MAP_SEARCH_PLACE: ENABLED_MAP_SEARCH_PLACE,
  MAX_SEARCH_PLACE: MAX_SEARCH_PLACE,
  DEFAULT_STATION_LOCATION: DEFAULT_STATION_LOCATION,
  DEFAULT_MY_LOCATION_RADIUS: DEFAULT_MY_LOCATION_RADIUS,
  JREAST_APP_SCHEMA: JREAST_APP_SCHEMA,
  JREAST_PC_SITE: JREAST_PC_SITE,
  MIXWAY_URL: MIXWAY_URL,
  REAL_TIME_SEARCH_WEB_LIST: REAL_TIME_SEARCH_WEB_LIST,
  LINK_BASE_URL: LINK_BASE_URL,
  API_BASE_URL: API_BASE_URL,
  BUS_LOCATION_API_URL: BUS_LOCATION_API_URL,
  BUS_LOCATION_API_KEY: BUS_LOCATION_API_KEY,
  BUS_LOCATION_TRIP_COUNT: BUS_LOCATION_TRIP_COUNT,
  REAL_TIME_SEARCH_WEB: REAL_TIME_SEARCH_WEB,
  API_KEY: API_KEY,
  MAX_SEARCH_STATION: MAX_SEARCH_STATION,
  QUESTIONNAIRE_URL: QUESTIONNAIRE_URL
}